import { Typography } from 'antd';

type CompoundedComponent = typeof Typography & {
  Title: typeof Typography.Title;
  Text: typeof Typography.Text;
  Paragraph: typeof Typography.Paragraph;
  Link: typeof Typography.Link;
};

const DarwinTypography: CompoundedComponent = Typography as CompoundedComponent;

DarwinTypography.Title = Typography.Title;
DarwinTypography.Text = Typography.Text;
DarwinTypography.Paragraph = Typography.Paragraph;
DarwinTypography.Link = Typography.Link;

export default DarwinTypography;
